import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import i18n from 'I18n';
import { getInboxUnreadCount, loginCommonNavItemList, unloginCommonNavItemList } from './NavigatorUtils';

const CenterComponent = ({
  language,
  isLogin,
  messageUnreadCount,
  navBarConfig,
  isMobile,
}) => {
  const inboxUnreadCount = useMemo(() => (
    getInboxUnreadCount(messageUnreadCount)
  ), [messageUnreadCount])

  if (isMobile) {
    return null;
  }

  if (!navBarConfig.webShowSections) {
    return null;
  }

  if (!isLogin) {
    return (
      <Nav className="header-center-container">
        {
          unloginCommonNavItemList.map(item => (
            <Nav.Item key={item.name}>
              <LinkContainer to={item.linkTo}>
                <div className="nav_div">{i18n.t(item.name)}</div>
              </LinkContainer>
            </Nav.Item>
          ))
        }
      </Nav>
    );
  };

  return (
    <Nav className="header-center-container">
      {
        loginCommonNavItemList.map(item => (
          <Nav.Item key={item.name}>
            <LinkContainer to={item.linkTo}>
              <div className="nav_div">
                {i18n.t(item.name)} {item.name === "home_inbox" && inboxUnreadCount}
              </div>
            </LinkContainer>
          </Nav.Item>
        ))
      }
    </Nav>
  );
};


const mapStateToProps = (state) => ({
  language: state.users.language,
  isLogin: state.users.isLogin,
  messageUnreadCount: state.inboxMessages.unReadCount,
});

export default connect(mapStateToProps)(CenterComponent);
